import { KuxFilteredCategoriesDTO, LCBatchesPresentationOrderEnum, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';
import { container } from 'tsyringe';

import { fetchChannelCollection } from '../../../../rhino';
import { queryClient } from '../../../../rhino/data/queryClient';
import { queryKeys } from '../../../../rhino/data/queryKeys';
import { CHANNELS_COLLECTION_FETCH_STALE_TIME } from '../../../../utils/constants';
import { errorHandling } from '../../../../utils/error-handling';
import { sortByOrderBatches } from '../../../../utils/sorting';
import { Linear } from '../../../entities';
import type { FavoriteRepository } from '../../../favoriteRepository';
import type { LinearRepository } from '../../../linearRepository/linear-repository';
import { SubpageStore } from '../subpage-store';

/**
 * @category Store
 */
export class FavoritesStore extends SubpageStore {
  static moduleName = 'FavoritesStore';

  subtype: UIDAPresentationTypeEnum.favorites = UIDAPresentationTypeEnum.favorites;

  static TTL: number;
  @observable isReady = false;
  @observable channelList: Linear[] = [];

  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children: [] = []) {
    super(props, categoryTree, children);
    FavoritesStore.TTL = categoryTree.favorites.favorites_ttl * 60 * 1000;
  }

  @action
  @errorHandling()
  async init() {
    super.init();
    this.isReady = false;

    const favoriteRepository = container.resolve<FavoriteRepository>('favoriteRepository');
    await favoriteRepository.getFavoritesList();

    const linearsData = await queryClient.fetchQuery({
      queryKey: queryKeys.channelCollection(this.referenceId),
      queryFn: () =>
        fetchChannelCollection({ channelId: this.channels[0], includeAdult: false, kSql: this.aggregatedKSQL }),
      staleTime: CHANNELS_COLLECTION_FETCH_STALE_TIME,
    });

    const linearRepository = container.resolve<LinearRepository>('linearRepository');

    this.channelList = sortByOrderBatches(
      linearsData.objects.map(({ id }) => linearRepository.getLinearById(id)).filter(linearRepository.isLinear),
      [LCBatchesPresentationOrderEnum.fav, LCBatchesPresentationOrderEnum.lcn],
    );

    this.isReady = true;
  }

  @action
  resetStore() {
    this.isReady = false;
    this.channelList = [];
  }
}
